import { api } from "../../src/config";
import store from "../redux/store";

import qs from "qs";

export const get_xcsrf_token = () => {
  const system = store.getState().systemReducer;

  return api({
    method: "get",
    url: `https://${system.subdomain}.companyapp.net` + "/session/token?_format=json",
  });
};

export const get_logout_token = () => {
  const system = store.getState().systemReducer;
  return api({
    method: "get",
    url: `https://${system.subdomain}.companyapp.net` + "/session/token/logout?_format=json",
  });
};

export const auth_login = (username, password) => {
  const system = store.getState().systemReducer;
  return api({
    method: "post",
    url: `https://${system.subdomain}.companyapp.net` + "/user/login?_format=json",
    // headers: {
    //   'X-CSRF-Token': xscrf_token,
    // },
    data: { name: username, pass: password },
  });
};

export const auth_logout = (logout_token, csrf_token) => {
  const system = store.getState().systemReducer;
  return api({
    method: "post",
    url: `https://${system.subdomain}.companyapp.net` + `/user/logout?_format=json&token=${logout_token}`,
    headers: {
      "X-CSRF-Token": csrf_token,
    },
  });
};

export const get_oauth_token = (username, password) => {
  const system = store.getState().systemReducer;
  const grant_type = "password";
  const data = {
    client_id: system.client_id,
    client_secret: system.client_secret,
    grant_type: grant_type,
    username: username,
    password: password,
  };

  return api({
    method: "post",
    url: `https://${system.subdomain}.companyapp.net` + "/oauth/token",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
